import { Box } from '@mui/material';
import { ReactNode } from 'react';

import { mobileAppWithEarbuds } from '@/assets';
import { ModalContentContainer } from '@/components';

export const AppLoginModalLayout = ({
  children,
  onModalClose,
}: {
  children?: ReactNode;
  onModalClose?: () => void;
}) => {
  return (
    <Box sx={{ width: { xs: '100%', md: '800px' } }}>
      <ModalContentContainer
        onModalClose={onModalClose}
        stretch
        leftColumnWidth={300}
        leftColumnContents={
          <Box sx={{ width: '100%' }}>
            <Box
              component="img"
              alt="mobile app"
              sx={{ width: '100%' }}
              src={mobileAppWithEarbuds}
            />
          </Box>
        }>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {children}
        </Box>
      </ModalContentContainer>
    </Box>
  );
};
